import { NgModule } from '@angular/core';
import { DeviceService } from './device';
import { HtmlRendererService } from './html-renderer';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [DeviceService, HtmlRendererService],
})
export class ToolsModule {}
